const lib=require('./glitchfx')
const glitcheditBridge = require('./glitchedit-bridge')
const bridgedEffects = glitcheditBridge.buildBridgedEffects()
const glitcheditDescriptors = glitcheditBridge.buildFxDescriptors(bridgedEffects)
const openmoshBridge = require('./openmosh-bridge')
const openmoshEffects = openmoshBridge.buildBridgedEffects()
const openmoshDescriptors = openmoshBridge.buildFxDescriptors(openmoshEffects)
const errorheadBridge = require('./errorhead-bridge')
const errorheadEffects = errorheadBridge.buildBridgedEffects()
const errorheadDescriptors = errorheadBridge.buildFxDescriptors(errorheadEffects)
const databenderBridge = require('./databender-bridge')
const databenderEffects = databenderBridge.buildBridgedEffects()
const databenderDescriptors = databenderBridge.buildFxDescriptors(databenderEffects)
const extraFx = require('./extra-fx')
const extraFxDescriptors = extraFx.descriptors
module.exports = [{
    name: 'base64_A',
    inputs: [
        {
            name: 'force',
            type:'knob',
            min: 0,
            max: 6,
            step: 1,
            value: 1
        }

    ],
    fn:lib.base64glitcher

},
{
    name: 'base64_B',
    inputs: [
        {
            name: 'force',
            type:'knob',
            min: 0,
            max: 6,
            step: 1,
            value: 1
        },
        {
            name: 'pass',
            type:'knob',
            min: 0,
            max: 3,
            step: 1,
            value: 0
        }

    ],
    fn:lib.rotatedbase64glitcher

},
{
    name: 'base64_C',
    inputs: [
        {
            name: 'force',
            type:'knob',
            min: 0,
            max: 100,
            step: 0.1,
            value: 10
        }

    ],
fn:lib.base64glitcher2
},
{
    name: 'latglitch',
    inputs: [
        {
            name: 'force',
            type:'knob',
            min: 0,
            max: 1,
            step: 0.01,
            value: 0.01
        }

    ],
    fn:lib.latglitch
}, {
    name: 'horizontal-splicer',
    inputs: [
        {
            name: 'force',
            type:'knob',
            min: 0,
            max: 100,
            step: 1,
            value: 1
        }

    ],
    fn:lib.horizontalsplicer
}
    , {
    name: 'vertical-splicer',
    inputs: [
        {
            name: 'force',
            type:'knob',
            min: 0,
            max: 100,
            step: 1,
            value: 1
        }

    ],
    fn:lib.verticalsplicer
},
{
    name: 'deconstruct',
    inputs: [
        {
            name: 'force',
            type:'knob',
            min: 0,
            max: 100,
            step: 1,
            value: 1
        }

    ],
    fn:lib.deconstruct
},


{
    name: 'slicer',
    inputs: [
        {
            name: 'force',
            type:'knob',
            min: 0,
            max: 200,
            step: 2,
            value: 2
        }

    ],
    fn:lib.Imgslice
},
{
    name: 'sinuglitch',
    inputs: [
        {
            name: 'wavelength',
            type:'knob',
            min: 0.1,
            max: 1,
            step: 0.001,
            value: 0.2
        },
        {
            name: 'periode',
            type:'knob',
            min: 0.1,
            max: 500,
            step: 0.1,
            value: 0.2
        },
        {
            name: 'amplitude',
            type:'knob',
            min: 0,
            max: 1000,
            step: 1,
            value: 0
        },
        {
            name: 'threshold',
            type:'knob',
            min: 0,
            max: 255,
            step: 1,
            value: 0
        }


    ],
    fn:lib.sinuglitch
},

{
    name: 'pixelsort',
    inputs: [
      
        {
            name: 'mode',
            type:'knob',
            min: 0,
            max: 10,
            step: 1,
            value: 1

        },
        {
            name: 'force',
            type:'knob',
            min: 0,
            max: 255,
            step: 1,
            value: 10

        },
        {
            name: 'r',
            type:'knob',
            min: 0,
            max: 255,
            step: 1,
            value: 1
        },
        {
            name: 'g',
            type:'knob',
            min: 0,
            max: 255,
            step: 1,
            value: 1
        },
        {
            name: 'b',
            type:'knob',
            min: 0,
            max: 255,
            step: 1,
            value: 1
        }

    ],
    fn:lib.pixelsort
},
{
    name: 'scanlines',
    inputs: [
        {
            name: "interval",
            type:'knob',
            min: 2,
            max: 20,
            step: 2,
            value: 2
        },
        {
            name: "opacity",
            type:'knob',
            min: 0,
            max: 1,
            step: 0.01,
            value: 1
        }
    ],
    fn:lib.scanlines
},
{
    name: 'jpeg',
    inputs: [
        {
            name: "reduction",
            type:'knob',
            min: 0,
            max: 1,
            step: 0.1,
            value: 1
        }
    ],
    fn:lib.jpeg
},
{
    name: 'rgb',
    inputs: [
        {
            name: "R",
            type:'knob',
            min: 0,
            max: 2000,
            step: 1,
            value: 1
        },
        {
            name: "G",
            type:'knob',
            min: 0,
            max: 2000,
            step: 1,
            value: 1
        },
        {
            name: "B",
            type:'knob',
            min: 0,
            max: 2000,
            step: 1,
            value: 1
        }
    ],
    fn:lib.rgbdesync
},
{
    name: 'flip',
    inputs: [
        {
            name: "mode",
            type:'knob',
            min: 0,
            max: 3,
            step: 1,
            value: 1
        }
 
    ],
    fn:lib.flip
},
{
    name: 'mirror',
    inputs: [
        {
            name: "mode",
            type:'knob',
            min: 0,
            max: 10,
            step: 1,
            value: 1
        }
 
    ],
    fn:lib.mirror
},
{
    name: 'invert',
    inputs: [
     
    ],
    fn:lib.invert
},
{
    name: 'brightness',
    inputs: [
        {
            name: "level",
            type:'knob',
            min: 0,
            max: 255,
            step: 1,
            value: 1
        }
    ],
    fn:lib.brightness
},
{
    name: 'contrast',
    inputs: [
        {
            name: "level",
            type:'knob',
            min: 0,
            max: 2,
            step: 0.001,
            value: 0
        }
    ],
    fn:lib.contrast
},
{
    name: 'RandBlocks',
    inputs: [
        {
            name: "size",
            type:'knob',
            min: 0,
            max: 100,
            step:1,
            value: 30
        },
        {
            name: "unified",
            type:'knob',
            min: 0,
            max: 1,
            step:1,
            value: 0
        }
    ],
    fn:lib.RandBlocks
},
{
    name: 'image particules',
    inputs: [
        {
            name: "angle",
            type:'knob',
            min: 0,
            max: 360,
            step:1,
            value: 30
        },
        {
            name: "cycles",
            type:'knob',
            min: 0,
            max: 20,
            step:1,
            value: 0
        },
        {
            name: "compositing",
            type:'knob',
            min: 0,
            max: 1,
            step:1,
            value: 0
        }
    ],
    fn:lib.ImageParticules
},
{
    name: 'fragment-shuffle',
    inputs: [
        {
            name: "echoes",
            type:'knob',
            min: 1,
            max: 10,
            step:1,
            value: 3
        }
    ],
    fn:lib.timeEcho
},
{
    name: 'blend-chaos',
    inputs: [
        {
            name: "layers",
            type:'knob',
            min: 1,
            max: 10,
            step:1,
            value: 5
        }
    ],
    fn:lib.compositeChaos
},
{
    name: 'channel-grid',
    inputs: [
        {
            name: "gridSize",
            type:'knob',
            min: 2,
            max: 20,
            step:1,
            value: 8
        }
    ],
    fn:lib.channelMosaic
},
{
    name: 'data-spin',
    inputs: [
        {
            name: "rotations",
            type:'knob',
            min: 1,
            max: 100,
            step:1,
            value: 10
        }
    ],
    fn:lib.dataVortex
},
{
    name: 'rift-portal',
    inputs: [
        {
            name: "rifts",
            type:'knob',
            min: 1,
            max: 20,
            step:1,
            value: 5
        }
    ],
    fn:lib.spectralRift
},
{
    name: 'wave-desync',
    inputs: [
        {
            name: "amplitude",
            type:'knob',
            min: 1,
            max: 50,
            step:1,
            value: 10
        },
        {
            name: "direction",
            type:'knob',
            min: 0,
            max: 360,
            step:1,
            value: 0
        }
    ],
    fn:lib.quantumChannelShift
},
{
    name: 'channel-reverse',
    inputs: [
        {
            name: "r-reverse",
            type:'knob',
            min: 0,
            max: 1,
            step:1,
            value: 0
        },
        {
            name: "g-reverse",
            type:'knob',
            min: 0,
            max: 1,
            step:1,
            value: 0
        },
        {
            name: "b-reverse",
            type:'knob',
            min: 0,
            max: 1,
            step:1,
            value: 0
        }
    ],
    fn:lib.channelReverse
},
{
    name: 'segment-twist',
    inputs: [
        {
            name: "segment-size",
            type:'knob',
            min: 1,
            max: 1000,
            step:1,
            value: 100
        }
    ],
    fn:lib.segmentTwist
},
{
    name: 'vertical-slice-glitch',
    inputs: [
        {
            name: "slice-height",
            type:'knob',
            min: 1,
            max: 100,
            step:1,
            value: 20
        },
        {
            name: "max-offset",
            type:'knob',
            min: 1,
            max: 200,
            step:1,
            value: 20
        }
    ],
    fn:lib.verticalSliceGlitch
},
{
    name: 'scanline-displace',
    inputs: [
        {
            name: "power",
            type:'knob',
            min: 0,
            max: 100,
            step:1,
            value: 10
        }
    ],
    fn:lib.scanlineDisplace
},
{
    name: 'row-duplication',
    inputs: [
        {
            name: "probability",
            type:'knob',
            min: 0,
            max: 1,
            step:0.01,
            value: 0.5
        }
    ],
    fn:lib.rowDuplication
},
{
    name: 'vertical-pixel-sort',
    inputs: [
        {
            name: "force",
            type:'knob',
            min: 1,
            max: 3000,
            step:1,
            value: 10
        },
        {
            name: "direction",
            type:'knob',
            min: 0,
            max: 10,
            step:1,
            value: 0
        }
    ],
    fn:lib.verticalPixelSort
},
{
    name: 'advanced-pixel-sort',
    inputs: [
        {
            name: "sort-mode",
            type:'knob',
            min: 0,
            max: 5,
            step:1,
            value: 0
        },
        {
            name: "direction",
            type:'knob',
            min: 0,
            max: 3,
            step:1,
            value: 0
        },
        {
            name: "separator-min",
            type:'knob',
            min: 0,
            max: 1,
            step:0.01,
            value: 0.1
        },
        {
            name: "separator-max",
            type:'knob',
            min: 0,
            max: 1,
            step:0.01,
            value: 0.9
        }
    ],
    fn:lib.advancedPixelSort
},
{
    name: 'neighbor-difference-sort',
    inputs: [
        {
            name: "intensity",
            type:'knob',
            min: 0,
            max: 1,
            step:0.01,
            value: 1
        }
    ],
    fn:lib.neighborDifferenceSort
},
{
    name: 'hsv-pixel-sort',
    inputs: [
        {
            name: "sort-order",
            type:'knob',
            min: 0,
            max: 5,
            step:1,
            value: 5
        }
    ],
    fn:lib.hsvPixelSort
},
{
    name: 'rgb-shift',
    inputs: [
        {
            name: "shift-r",
            type:'knob',
            min: -100,
            max: 100,
            step:1,
            value: 10
        },
        {
            name: "shift-g",
            type:'knob',
            min: -100,
            max: 100,
            step:1,
            value: -5
        },
        {
            name: "shift-b",
            type:'knob',
            min: -100,
            max: 100,
            step:1,
            value: 15
        },
        {
            name: "blend",
            type:'knob',
            min: 0,
            max: 1,
            step:0.1,
            value: 0.8
        }
    ],
    fn:lib.shiftRGB
},
{
    name: 'tv-static',
    inputs: [
        {
            name: "amount",
            type:'knob',
            min: 0,
            max: 1,
            step:0.01,
            value: 0.5
        },
        {
            name: "monochrome",
            type:'knob',
            min: 0,
            max: 1,
            step:1,
            value: 0
        }
    ],
    fn:lib.tvStatic
},
{
    name: 'sobel-edge-glitch',
    inputs: [
        {
            name: "threshold",
            type:'knob',
            min: 0,
            max: 255,
            step:1,
            value: 50
        },
        {
            name: "sort-intensity",
            type:'knob',
            min: 0,
            max: 100,
            step:1,
            value: 50
        },
        {
            name: "edge-mode",
            type:'knob',
            min: 0,
            max: 2,
            step:1,
            value: 0
        },
        {
            name: "blend-amount",
            type:'knob',
            min: 0,
            max: 1,
            step:0.1,
            value: 0.5
        }
    ],
    fn:lib.sobelEdgeGlitch
},
{
    name: 'vertical-slice-offset',
    inputs: [
        {
            name: "slice-height",
            type:'knob',
            min: 1,
            max: 200,
            step:1,
            value: 20
        },
        {
            name: "max-offset",
            type:'knob',
            min: 0,
            max: 500,
            step:1,
            value: 100
        },
        {
            name: "probability",
            type:'knob',
            min: 0,
            max: 1,
            step:0.01,
            value: 0.99
        },
        {
            name: "vertical-jitter",
            type:'knob',
            min: 0,
            max: 100,
            step:1,
            value: 0
        }
    ],
    fn:lib.verticalSliceOffset
},
{
    name: 'horizontal-shift-lines',
    inputs: [
        {
            name: "rows",
            type:'knob',
            min: 1,
            max: 100,
            step:1,
            value: 6
        },
        {
            name: "max-shift",
            type:'knob',
            min: 1,
            max: 200,
            step:1,
            value: 40
        },
        {
            name: "min-height",
            type:'knob',
            min: 1,
            max: 100,
            step:1,
            value: 1
        },
        {
            name: "max-height",
            type:'knob',
            min: 1,
            max: 500,
            step:1,
            value: 50
        }
    ],
    fn:lib.horizontalShiftLines
},
{
    name: 'slice-displacement',
    inputs: [
        {
            name: "slices",
            type:'knob',
            min: 1,
            max: 500,
            step:1,
            value: 60
        },
        {
            name: "blend-mode",
            type:'knob',
            min: 0,
            max: 16,
            step:1,
            value: 0
        },
        {
            name: "opacity",
            type:'knob',
            min: 0,
            max: 1,
            step:0.1,
            value: 1
        },
        {
            name: "min-height",
            type:'knob',
            min: 1,
            max: 100,
            step:1,
            value: 5
        }
    ],
    fn:lib.sliceDisplacement
},
{
    name: 'kaleidoscope-glitch',
    inputs: [
        {
            name: "segments",
            type:'knob',
            min: 2,
            max: 16,
            step:1,
            value: 6
        },
        {
            name: "color-shift",
            type:'knob',
            min: 0,
            max: 360,
            step:1,
            value: 180
        },
        {
            name: "rotation",
            type:'knob',
            min: 0,
            max: 360,
            step:1,
            value: 0
        },
        {
            name: "chaos",
            type:'knob',
            min: 0,
            max: 100,
            step:1,
            value: 0
        }
    ],
    fn:lib.kaleidoscopeGlitch
},
{
    name: 'threshold-pixel-sort',
    inputs: [
        {
            name: "min-threshold",
            type:'knob',
            min: 0,
            max: 255,
            step:1,
            value: 0
        },
        {
            name: "max-threshold",
            type:'knob',
            min: 0,
            max: 255,
            step:1,
            value: 255
        },
        {
            name: "sort-mode",
            type:'knob',
            min: 0,
            max: 5,
            step:1,
            value: 0
        },
        {
            name: "direction",
            type:'knob',
            min: 0,
            max: 3,
            step:1,
            value: 0
        }
    ],
    fn:lib.thresholdPixelSort
},
// ===========================================================================
// Dithering FX (ported from Oslonline/dithering-studio, Apache-2.0)
// Error diffusion FX: args = (threshold, serpentine, invert, strength)
// Ordered/other FX:   args = (threshold, invert)
// ===========================================================================
{
    name: 'dither-floyd-steinberg',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'serpentine', type: 'knob', min: 0, max: 1, step: 1, value: 1 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 },
        { name: 'strength', type: 'knob', min: 0, max: 200, step: 1, value: 100 }
    ],
    fn: lib.ditherFloydSteinberg
},
{
    name: 'dither-false-floyd-steinberg',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'serpentine', type: 'knob', min: 0, max: 1, step: 1, value: 1 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 },
        { name: 'strength', type: 'knob', min: 0, max: 200, step: 1, value: 100 }
    ],
    fn: lib.ditherFalseFloydSteinberg
},
{
    name: 'dither-atkinson',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'serpentine', type: 'knob', min: 0, max: 1, step: 1, value: 0 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 },
        { name: 'strength', type: 'knob', min: 0, max: 200, step: 1, value: 100 }
    ],
    fn: lib.ditherAtkinson
},
{
    name: 'dither-sierra-lite',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'serpentine', type: 'knob', min: 0, max: 1, step: 1, value: 1 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 },
        { name: 'strength', type: 'knob', min: 0, max: 200, step: 1, value: 100 }
    ],
    fn: lib.ditherSierraLite
},
{
    name: 'dither-burkes',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'serpentine', type: 'knob', min: 0, max: 1, step: 1, value: 1 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 },
        { name: 'strength', type: 'knob', min: 0, max: 200, step: 1, value: 100 }
    ],
    fn: lib.ditherBurkes
},
{
    name: 'dither-stucki',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'serpentine', type: 'knob', min: 0, max: 1, step: 1, value: 1 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 },
        { name: 'strength', type: 'knob', min: 0, max: 200, step: 1, value: 100 }
    ],
    fn: lib.ditherStucki
},
{
    name: 'dither-sierra',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'serpentine', type: 'knob', min: 0, max: 1, step: 1, value: 1 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 },
        { name: 'strength', type: 'knob', min: 0, max: 200, step: 1, value: 100 }
    ],
    fn: lib.ditherSierra
},
{
    name: 'dither-jjn',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'serpentine', type: 'knob', min: 0, max: 1, step: 1, value: 1 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 },
        { name: 'strength', type: 'knob', min: 0, max: 200, step: 1, value: 100 }
    ],
    fn: lib.ditherJJN
},
{
    name: 'dither-two-row-sierra',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'serpentine', type: 'knob', min: 0, max: 1, step: 1, value: 1 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 },
        { name: 'strength', type: 'knob', min: 0, max: 200, step: 1, value: 100 }
    ],
    fn: lib.ditherTwoRowSierra
},
{
    name: 'dither-stevenson-arce',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'serpentine', type: 'knob', min: 0, max: 1, step: 1, value: 0 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 },
        { name: 'strength', type: 'knob', min: 0, max: 200, step: 1, value: 100 }
    ],
    fn: lib.ditherStevensonArce
},
{
    name: 'dither-sierra-2-4a',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'serpentine', type: 'knob', min: 0, max: 1, step: 1, value: 1 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 },
        { name: 'strength', type: 'knob', min: 0, max: 200, step: 1, value: 100 }
    ],
    fn: lib.ditherSierra24A
},
{
    name: 'dither-ostromoukhov',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'serpentine', type: 'knob', min: 0, max: 1, step: 1, value: 1 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 },
        { name: 'strength', type: 'knob', min: 0, max: 200, step: 1, value: 100 }
    ],
    fn: lib.ditherOstromoukhov
},
{
    name: 'dither-adaptive-fs-3x3',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'serpentine', type: 'knob', min: 0, max: 1, step: 1, value: 1 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 },
        { name: 'strength', type: 'knob', min: 0, max: 200, step: 1, value: 100 }
    ],
    fn: lib.ditherAdaptiveFS3
},
{
    name: 'dither-adaptive-fs-7x7',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'serpentine', type: 'knob', min: 0, max: 1, step: 1, value: 1 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 },
        { name: 'strength', type: 'knob', min: 0, max: 200, step: 1, value: 100 }
    ],
    fn: lib.ditherAdaptiveFS7
},
{
    name: 'dither-riemersma',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'serpentine', type: 'knob', min: 0, max: 1, step: 1, value: 0 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 },
        { name: 'strength', type: 'knob', min: 0, max: 200, step: 1, value: 100 }
    ],
    fn: lib.ditherRiemersma
},
{
    name: 'dither-bayer-2x2',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 }
    ],
    fn: lib.ditherBayer2
},
{
    name: 'dither-bayer-4x4',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 }
    ],
    fn: lib.ditherBayer4
},
{
    name: 'dither-bayer-8x8',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 }
    ],
    fn: lib.ditherBayer8
},
{
    name: 'dither-bayer-16x16',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 }
    ],
    fn: lib.ditherBayer16
},
{
    name: 'dither-bayer-32x32',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 }
    ],
    fn: lib.ditherBayer32
},
{
    name: 'dither-blue-noise',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 }
    ],
    fn: lib.ditherBlueNoise
},
{
    name: 'dither-binary-threshold',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 }
    ],
    fn: lib.ditherBinaryThreshold
},
{
    name: 'dither-halftone',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 }
    ],
    fn: lib.ditherHalftone
},
{
    name: 'dither-random-threshold',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 }
    ],
    fn: lib.ditherRandomThreshold
},
{
    name: 'dither-dot-diffusion',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 }
    ],
    fn: lib.ditherDotDiffusion
},
{
    name: 'dither-ascii-mosaic',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 }
    ],
    fn: lib.ditherAsciiMosaic
},
{
    name: 'dither-posterize',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 }
    ],
    fn: lib.ditherPosterize
},
{
    name: 'dither-woodcut',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 }
    ],
    fn: lib.ditherWoodcut
},
{
    name: 'dither-stipple',
    inputs: [
        { name: 'threshold', type: 'knob', min: 0, max: 255, step: 1, value: 128 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 }
    ],
    fn: lib.ditherStipple
},
// ===========================================================================
// Fuegocoding dither FX (ported from fuegocoding/dither)
// Grid-based patterns: rotated-sine halftone, hash noise, crosshatch
// Args: (gridSize, threshold, invert) — threshold is 0..1 normalized
// ===========================================================================
{
    name: 'dither-fc-halftone',
    inputs: [
        { name: 'grid-size', type: 'knob', min: 1, max: 16, step: 1, value: 2 },
        { name: 'threshold', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.5 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 }
    ],
    fn: lib.ditherFcHalftone
},
{
    name: 'dither-fc-noise',
    inputs: [
        { name: 'grid-size', type: 'knob', min: 1, max: 16, step: 1, value: 2 },
        { name: 'threshold', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.5 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 }
    ],
    fn: lib.ditherFcNoise
},
{
    name: 'dither-fc-crosshatch',
    inputs: [
        { name: 'grid-size', type: 'knob', min: 1, max: 16, step: 1, value: 2 },
        { name: 'threshold', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.5 },
        { name: 'invert', type: 'knob', min: 0, max: 1, step: 1, value: 0 }
    ],
    fn: lib.ditherFcCrosshatch
},
...glitcheditDescriptors,
...openmoshDescriptors,
...errorheadDescriptors,
...databenderDescriptors,
...extraFxDescriptors
]
